import { getProductBase } from '@libs/api-proxy-client';
import type { ProductApiResponse } from '@libs/common-types';
import { logger } from '@libs/core';

export const fetchMiniPdpProductBase = async (id: string): Promise<ProductApiResponse | null> => {
    try {
        return await getProductBase(id);
    } catch (error) {
        const statusCode = (error as { statusCode?: number })?.statusCode;

        if (statusCode === 404) {
            logger.warn('[MINI PDP FETCH PRODUCT BASE][Warn]: %o', error);
            return null;
        }

        logger.error('[MINI PDP FETCH PRODUCT BASE][Error]: %o', error);
        return null;
    }
};
